// @flow
import Api from './ApiWorker';

export const sentEmail = (params: any): Promise<BackEndResponse<any>> =>
	Api.send<any>({
		url: '/email/sent',
		method: 'POST',
		body: params,
		secure: false,
	});
